import React from 'react';
import { AssetUrls } from 'config/assets';
import './HaveListFoilButton.css';

const FOIL_ICON = `${AssetUrls.base}/assets/add-cards/foil.png`;

interface HaveListFoilButtonProps {
  isFoil: boolean;
  foilAvailable: boolean;
  cardName: string;
  onToggle: (newFoil: boolean) => void;
}

export const HaveListFoilButton: React.FC<HaveListFoilButtonProps> = ({
  isFoil,
  foilAvailable,
  cardName,
  onToggle,
}) => {
  const disabled = !foilAvailable;

  const title = disabled
    ? 'This card has no foil printing available'
    : isFoil
      ? 'Foil — click to mark non-foil'
      : 'Non-foil — click to mark foil';

  const classes = ['have-list-foil-toggle', isFoil ? 'active' : '']
    .filter(Boolean)
    .join(' ');

  return (
    <div
      className="collection-card-foil-toggle"
      onClick={(e) => e.stopPropagation()}
    >
      <button
        type="button"
        className={classes}
        onClick={(e) => {
          e.stopPropagation();
          if (disabled) return;
          onToggle(!isFoil);
        }}
        aria-pressed={isFoil}
        aria-label={`Toggle foil status for ${cardName}`}
        title={title}
        disabled={disabled}
      >
        <img
          src={FOIL_ICON}
          alt=""
          aria-hidden="true"
          width={14}
          height={14}
          className="have-list-foil-toggle__icon"
        />
      </button>
    </div>
  );
};

export default HaveListFoilButton;
